import { ReactNode } from 'react';

import { IStore } from 'features/store/pages/pickup-store-selector/ducks/stores';

import { IBaseProps } from '@rbi-ctg/frontend';
import { ILocation } from '@rbi-ctg/frontend';

import { StoreLocatorAction, StoreLocatorActions } from '../types';

export interface IStoreLocatorMapProps extends IBaseProps {
  map: ReactNode;
}

export enum FocusedBy {
  MAP = 'map',
  LIST = 'list',
  GLOBAL = 'global',
}

export type FocusTarget = 'restaurant' | 'userLocation' | 'area';

export interface IMapViewProps {
  onCenterToUserLocation: () => void;
  onPressSearchThisArea: (location: ILocation) => void;
  onMarkerPress?: ({ restaurant, focusedBy }: { restaurant: IStore; focusedBy: FocusedBy }) => void;
  onSelectStore?: (storeId: string) => void;
  storesFavs: IStore[];
  isInSupportForm?: boolean;
  restaurantFocused: IStore | null;
  actions: React.MutableRefObject<StoreLocatorActions>;
  closestStore: IStore | null;
  stores: IStore[];
  activeStore: IStore | null;
  searchingNearby: boolean;
}

export type FocusConfig = {
  restaurant?: IStore;
  focusReason?: StoreLocatorAction;
  coordinates?: ILocation;
};

export type MapViewRef = {
  focus: (config: FocusConfig) => void;
  mapIsReady: boolean;
};
